class MatchQuiz extends HTMLElement {
  connectedCallback() {
    const form = this.querySelector('[data-quiz-form]');
    if (!form) return;
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const data = new FormData(form);
      const score = ['q1', 'q2', 'q3'].reduce((sum, key) => sum + Number(data.get(key) || 0), 0);
      const match = score <= 4 ? '1' : score <= 7 ? '2' : '3';
      for (const result of this.querySelectorAll('[data-quiz-result]')) {
        result.hidden = result.dataset.quizResult !== match;
      }
      const shown = this.querySelector(`[data-quiz-result="${match}"]`);
      shown?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    });
  }
}

if (!customElements.get('match-quiz')) customElements.define('match-quiz', MatchQuiz);
